
















































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { TbMember } from '@/http';
import { fmoney } from '@/common/money';
@Component({
    components: {
    },
})
export default class returnDetailPopPanel extends Vue {
    public $refs: {
    };

    @Prop({
        default:false
    })
    show:Boolean;

    @Prop({
        type:Object,
        default:()=>{
            return {}
        }
    })
    form:any;

    fmoney = fmoney;


    created() {
    }   
    
    mounted() {
       
    }

    closeFun(){
        this.$emit('closeFun');
    }
    confirmFun(){
        this.$emit('confirmFun');
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/returnDetailPopPanel.vue